module.exports = __webpack_public_path__ + "img/yishi5.f04902a7.jpg";